const Family = ({...props}) => {
	return (
		<div className="app__" >
			Family
		</div>
	)
}
export default Family
